
const routes = [
  // {
  //   path: '/ap',
  //   name: 'ap-login',
  //   component: () => import(/* webpackChunkName: "ap-login" */ '@/views/ap/Login.vue')
  // },
  {
    path: '/ap',
    meta: { requiresAuth: true },
    component: () => import(/* webpackChunkName: "ap-layout" */ '@/views/ap/_Layout.vue'),
    children: [
      {
        path: 'forside',
        name: 'ap-home',
        component: () => import(/* webpackChunkName: "ap-home" */ '@/views/ap/Home.vue')
      },
      {
        path: 'registrering',
        name: 'ap-register',
        component: () => import(/* webpackChunkName: "ap-register" */ '@/views/ap/Register.vue'),
        // children: [
        //   {
        //     path: 'detaljer',
        //     name: 'ap-register-details',
        //     component: () => import(/* webpackChunkName: "ap-register-details" */ '@/views/ap/RegisterDetails.vue')
        //   },
        //   {
        //     path: 'kapasitet',
        //     name: 'ap-register-capacity',
        //     component: () => import(/* webpackChunkName: "ap-register-capacity" */ '@/views/ap/RegisterCapacity.vue')
        //   },
        //   {
        //     path: 'profil',
        //     name: 'ap-register-profile',
        //     component: () => import(/* webpackChunkName: "ap-register-profile" */ '@/views/ap/RegisterProfile.vue')
        //   },
        // ]
      },
      {
        path: 'resultater',
        name: 'ap-results',
        component: () => import(/* webpackChunkName: "ap-results" */ '@/views/ap/Results.vue')
      },
    ]
  },

]

export default routes